
import ProductsPage from '~/components/ProductsPage'
export default {
  auth: false,
  components: {
    ProductsPage
  }
}
